import React from 'react';
interface MonogramProps {
  size?: number;
  className?: string;
}
export function Monogram({
  size = 240,
  className = ''
}: MonogramProps) {
  const id = 'monogram-circle';
  return <svg width={size} height={size} viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Anisley Estanque Insurance Services" data-id="element-259">
      <defs data-id="element-260">
        {/* Curved path for top text */}
        <path id={`${id}-top`} d="M 30,120 A 90,90 0 0 1 210,120" fill="none" data-id="element-261" />
        {/* Curved path for bottom text */}
        <path id={`${id}-bottom`} d="M 30,120 A 90,90 0 0 0 210,120" fill="none" data-id="element-262" />
        <linearGradient id={`${id}-gold`} x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-263">
          <stop offset="0%" stopColor="#d4af37" data-id="element-264" />
          <stop offset="50%" stopColor="#c9a961" data-id="element-265" />
          <stop offset="100%" stopColor="#a88a4a" data-id="element-266" />
        </linearGradient>
      </defs>

      {/* Outer thin ring */}
      <circle cx="120" cy="120" r="115" fill="none" stroke={`url(#${id}-gold)`} strokeWidth="0.8" data-id="element-267" />

      {/* Inner thicker ring (where text sits) */}
      <circle cx="120" cy="120" r="100" fill="none" stroke={`url(#${id}-gold)`} strokeWidth="1.5" data-id="element-268" />

      {/* Innermost ring */}
      <circle cx="120" cy="120" r="78" fill="none" stroke={`url(#${id}-gold)`} strokeWidth="0.6" opacity="0.6" data-id="element-269" />

      {/* Curved top text */}
      <text fill={`url(#${id}-gold)`} style={{
      fontFamily: 'Inter, sans-serif',
      fontSize: '11px',
      letterSpacing: '0.45em',
      fontWeight: 500
    }} data-id="element-270">
        <textPath href={`#${id}-top`} startOffset="50%" textAnchor="middle" data-id="element-271">
          ANISLEY ESTANQUE
        </textPath>
      </text>

      {/* Curved bottom text */}
      <text fill={`url(#${id}-gold)`} style={{
      fontFamily: 'Inter, sans-serif',
      fontSize: '8px',
      letterSpacing: '0.55em',
      fontWeight: 500
    }} data-id="element-272">
        <textPath href={`#${id}-bottom`} startOffset="50%" textAnchor="middle" data-id="element-273">
          INSURANCE SERVICES · EST. 2024
        </textPath>
      </text>

      {/* Decorative star/diamond separators on sides */}
      <g fill={`url(#${id}-gold)`} data-id="element-274">
        <polygon points="20,120 24,116 28,120 24,124" data-id="element-275" />
        <polygon points="212,120 216,116 220,120 216,124" data-id="element-276" />
      </g>

      {/* Center monogram AE — italic serif, interlaced */}
      <g transform="translate(120, 120)" data-id="element-277">
        {/* A */}
        <text x="-8" y="20" textAnchor="middle" fill={`url(#${id}-gold)`} style={{
        fontFamily: '"Playfair Display", serif',
        fontSize: '90px',
        fontStyle: 'italic',
        fontWeight: 700
      }} data-id="element-278">
          A
        </text>
        {/* E - overlapping */}
        <text x="18" y="28" textAnchor="middle" fill={`url(#${id}-gold)`} style={{
        fontFamily: '"Playfair Display", serif',
        fontSize: '78px',
        fontStyle: 'italic',
        fontWeight: 600
      }} opacity="0.95" data-id="element-279">
          E
        </text>
      </g>

      {/* Tiny ornamental flourish below monogram */}
      <g transform="translate(120, 165)" fill={`url(#${id}-gold)`} data-id="element-280">
        <circle cx="-12" cy="0" r="1" data-id="element-281" />
        <circle cx="12" cy="0" r="1" data-id="element-282" />
        <line x1="-9" y1="0" x2="9" y2="0" stroke={`url(#${id}-gold)`} strokeWidth="0.6" data-id="element-283" />
        <polygon points="0,-3 3,0 0,3 -3,0" data-id="element-284" />
      </g>
    </svg>;
}